import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { Button } from '@material-ui/core';

const columnData = [
	{
		id: 'name',
		numeric: false,
		disablePadding: true,
		label: 'Location Name'
	},
	{ id: 'address', numeric: false, disablePadding: false, label: 'Address' },
	{ id: 'city', numeric: false, disablePadding: false, label: 'City' },
	{ id: 'province', numeric: false, disablePadding: false, label: 'Province' }
];

class EnhancedTableHead extends React.Component {
	createSortHandler = property => event => {
		this.props.onRequestSort(event, property);
	};

	render() {
		const provinceLabel = this.props.provinceLabel || 'Province';
		const {
			onSelectAllClick,
			order,
			orderBy,
			allSelected
		} = this.props;

		return (
			<TableHead>
				<TableRow>
					<TableCell
						padding="checkbox"
						style={{ width: 156, whiteSpace: 'nowrap' }}
					>
						<Button
							onClick={onSelectAllClick}
							variant="outlined"
							size="small"
							disableElevation
							style={{
								backgroundColor: 'transparent',
								color: '#c655d6',
								border: '1px solid rgba(198, 85, 214, 0.55)',
								textTransform: 'none',
								fontWeight: 600,
								minWidth: 132,
							}}
						>
							{allSelected ? 'Deselect all' : 'Select all'}
						</Button>
					</TableCell>
					{columnData.map(column => (
						<TableCell
							key={column.id}
							numeric={column.numeric}
							padding={column.disablePadding ? 'none' : 'default'}
							sortDirection={
								orderBy === column.id ? order : false
							}
						>
							<TableSortLabel
								active={orderBy === column.id}
								direction={order}
								onClick={this.createSortHandler(column.id)}
							>
								{column.id === 'province'
									? provinceLabel
									: column.label}
							</TableSortLabel>
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

EnhancedTableHead.propTypes = {
	provinceLabel: PropTypes.string,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
	allSelected: PropTypes.bool
};

export default EnhancedTableHead;



// WEBPACK FOOTER //
// ./src/components/add_accounts/EnhancedTableHead.js